/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.sticky = this.dataset.sticky;
        this.form = this.querySelector('form');
        if (!this.sticky) {
          if (this.form) this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        this.cartNotification = document.querySelector('cart-notification');
        this.body = document.body;
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButtons = this.querySelectorAll('.single-add-to-cart-button');

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains('loading')) return;
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        });

        let submitCustomButton = document.querySelector('.product-submit.custom__btn');
        if (submitCustomButton) submitCustomButton.setAttribute('disabled', 'disabled');

        this.handleErrorMessage();

        let formData = new FormData(this.form);
        if (formData.get('properties[GIFTING]') != null) {
          formData.delete('properties[GIFTING]');
        }
        if ((this.dataset.section || '').includes('main-search')) {
          const productForm = this.closest('product-form');
          const shipOnDate = productForm?.dataset?.shipOnDate || '';
          const today = new Date();
          const todayISO = new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString().slice(0, 10);
          const shouldInject = !formData.get('properties[PREORDER]') && shipOnDate && shipOnDate >= todayISO;
          if (shouldInject) {
            formData.append('properties[PREORDER]', shipOnDate);
          }
        }
        if ((this.dataset.section || '').includes('recommendations')) {
          const productForm = this.closest('product-form');
          const shipOnDate = productForm?.dataset?.shipOnDate || '';
          const today = new Date();
          const todayISO = new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString().slice(0, 10);
          const shouldInject = !formData.get('properties[PREORDER]') && shipOnDate && shipOnDate >= todayISO;
          if (shouldInject) {
            formData.append('properties[PREORDER]', shipOnDate);
          }
        }

        const sectionList = this.getSectionsToRender().map((section) => section.section);

        const onAdded = (data) => {
          const addedProduct = data && data.hasOwnProperty('items') ? data.items[0] : data;
          const cartStatus = document.getElementById('cart-status');
          if (cartStatus && addedProduct) {
            cartStatus.textContent =
              (addedProduct.product_title || addedProduct.title || 'Item') + ' added to your cart';
          }
          if (typeof window.triggerKlaviyoATCEvent === 'function') window.triggerKlaviyoATCEvent(data);
          this.openCartDrawerAfterAdd();
        };
        const onAddError = (data) => {
          dispatchCustomEvent('product:variant-error', {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: data && data.description,
            message: data && data.message,
          });
          this.handleErrorMessage(data && data.description);
        };

        const request = window.theme.cartAPI
          .addItem(formData, { sections: sectionList, sectionsUrl: window.location.pathname })
          .then((result) => onAdded(result.added), (error) => onAddError(error));

        request
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              if (!submitButton.classList.contains('single-trip-add-to-cart-button')) {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
              }
            });
            if (submitCustomButton) submitCustomButton.removeAttribute('disabled');
            let cartJson = document.querySelector('[id^=cartJson');
            let cartItems = cartJson ? JSON.parse(cartJson.innerHTML) : null;
            let variantJson = document.querySelector('[id^=variantJson');
            let variantItems = variantJson ? JSON.parse(variantJson.innerHTML) : null;
            let selectedVariantInput = document.querySelector(
              '.thb-product-detail input[name="id"]'
            );
            if (selectedVariantInput) {
              let selectedVariantInputValue = selectedVariantInput.value;
              let variantObj = variantItems?.find((item) => item.id == selectedVariantInputValue);
              let cartItemObj = cartItems?.find((item) => item.id == selectedVariantInputValue);
              if (!variantObj?.available) {
                let disableBtn = true;
                let btnText = window.theme.variantStrings.soldOut;
                if (submitCustomButton) {
                  submitCustomButton.setAttribute('disabled', 'disabled');
                  submitCustomButton.textContent = window.theme.variantStrings.soldOut;
                }
                submitButtons.forEach((submitButton) => {
                  if (submitButton.classList.contains('single-trip-add-to-cart-button')) {
                    let submitButtonText = submitButton.querySelector(
                      '.single-add-to-cart-button--text'
                    );
                    if (!submitButtonText) return;
                    if (disableBtn) {
                      submitButton.setAttribute('disabled', 'disabled');
                      if (btnText) submitButtonText.textContent = btnText;
                    } else {
                      submitButton.removeAttribute('disabled');
                      submitButton.classList.remove('loading');
                      submitButtonText.textContent = btnText;
                    }
                  }
                });
              } else {
                let inventoryQty = variantObj?.inventory_quantity;
                let disableBtn = false;
                let btnText = window.theme.variantStrings.addToCart;
                if (cartItemObj) {
                  if (cartItemObj?.quantity >= inventoryQty) {
                    disableBtn = true;
                    btnText = window.theme.variantStrings.soldOut;
                  }
                }
                if (disableBtn) {
                  if (submitCustomButton) {
                    submitCustomButton.setAttribute('disabled', 'disabled');
                    submitCustomButton.textContent = window.theme.variantStrings.soldOut;
                  }
                }
                let submitButtonsupdate = document.querySelectorAll('.single-add-to-cart-button');
                submitButtonsupdate.forEach((submitButton) => {
                  if (submitButton.classList.contains('single-trip-add-to-cart-button')) {
                    let submitButtonText = submitButton.querySelector(
                      '.single-add-to-cart-button--text'
                    );
                    if (!submitButtonText) return;
                    if (disableBtn) {
                      submitButton.setAttribute('disabled', 'disabled');
                      if (btnText) submitButtonText.textContent = btnText;
                    } else {
                      submitButton.removeAttribute('disabled');
                      submitButton.classList.remove('loading');
                      submitButtonText.textContent = btnText;
                    }
                  }
                });
              }
            }
          });
      }

      getSectionsToRender() {
        const sections = [
          {
            id: 'Cart',
            section: 'main-cart',
            selector: '.thb-cart-form',
          },
          {
            id: 'Cart-Drawer',
            section: 'cart-drawer',
            selector: '.cart-drawer',
          },
          {
            id: 'cart-drawer-toggle',
            section: 'cart-bubble',
            selector: '.thb-item-count',
          },
        ];

        let submitCustomButton = document.querySelector('.product-submit.custom__btn');
        if (submitCustomButton) {
          sections.push({
            id: 'jsonData',
            section: document.querySelector('.thb-product-detail[data-id]').dataset.id,
            selector: '.jsonData',
          });
        }
        return sections;
      }

      openCartDrawerAfterAdd() {
        let product_drawer = document.getElementById('Product-Drawer');
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer
            .querySelector('.product-quick-images--container')
            .classList.remove('active');
          document.body.classList.remove('open-quick-view');

          if (window.innerWidth < 1069) {
            product_drawer.classList.remove('active');
            window.cartDrawer.openWhenReady();
          } else {
            product_drawer
              .querySelector('.product-quick-images--container')
              .addEventListener('transitionend', function () {
                product_drawer.classList.remove('active');
                window.cartDrawer.openWhenReady();
              });
          }

          if (!document.getElementById('Cart-Drawer')) {
            document.body.classList.remove('open-cc');
          }
        } else {
          window.cartDrawer.openWhenReady();
        }
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
